// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchHomeSections, addHomeSection, updateHomeSection } from "../../api/homeSectionApi";

// Async thunks for homeSection operations

export const getHomeSections = createAsyncThunk(
  "homeSection/getHomeSections",
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchHomeSections();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createHomeSection = createAsyncThunk(
  "homeSection/createHomeSection",
  async (newHomeSection: { title: string; description: string; is_active: boolean; image?: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addHomeSection(newHomeSection);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editHomeSection = createAsyncThunk(
  "homeSection/editHomeSection",
  async (
    {  updatedHomeSection }: {  updatedHomeSection: { title: string; description: string; is_active: boolean; image?: string } },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await updateHomeSection( updatedHomeSection);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// HomeSection Slice

const homeSectionSlice = createSlice({
  name: "homeSection",
  initialState: {
    homeSections: [] as any[],
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all home sections
      .addCase(getHomeSections.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.homeSections = action.payload;
      })
      .addCase(getHomeSections.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Create home section
      .addCase(createHomeSection.fulfilled, (state, action: PayloadAction<any>) => {
        if (Array.isArray(state.homeSections)) {
          state.homeSections.push(action.payload);
          state.status = true;
          state.msg = "Home section created successfully.";
        } else {
           // // // console.log("homeSections not an array");
        }
      })
      .addCase(createHomeSection.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Edit home section
      .addCase(editHomeSection.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.homeSections)) {
          const index = state.homeSections.findIndex((section) => section.id === id);
          if (index !== -1) {
            state.homeSections[index] = data;
          }
          state.status = true;
          state.msg = "Home section updated successfully.";
        } else {
           // // // console.log("homeSections not an array");
        }
      })
      .addCase(editHomeSection.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetStatus } = homeSectionSlice.actions;
export default homeSectionSlice.reducer;
